export const ColorTypes: { [key: string]: string } = {
  white: '#ffffff',
  soft_pink: '#eb539f',
  moderate_green: '#81d653',
  bright_blue : '#479FF8'
}
